import { computed, inject, Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { ActiveDirectoryAbstraction } from "@app/shared-core/abstractions/active-directory.abstraction";
import { IBaseDirectory } from "@app/shared-core/interfaces/base-directory.interface";
import { AuthService } from "@app/shared/auth/services/auth.service";
import { UserService } from "@app/shared/users/users/services/user.service";

@Injectable({ providedIn: "root" })
export class ActiveDirectoryService extends ActiveDirectoryAbstraction {
  private readonly authService = inject(AuthService);
  private readonly userService = inject(UserService);

  private readonly user = computed(() => this.authService.user());
  public readonly activeDirectory = computed(() => this.user()?.activeDirectory ?? null);
  public readonly availableDirectories = computed(() => this.user()?.directories ?? []);

  changeActiveDirectory(id: string): Observable<IBaseDirectory | null> {
    return this.userService.changeMyActiveDirectory(id).pipe(map(user => user?.activeDirectory ?? null));
  }
}
